import { useAnimalStore } from '../../Stores/animalStore'
import { t } from '../../i18n'
import { ActionsHeader, Header, Row, Table } from '../TablePacks/styles'
import { RowInsured } from './RowInsured'

export const TableInsured = () => {
  const { animalsList } = useAnimalStore()
  return (
    <Table>
      <thead>
        <Row>
          <Header>{t('table.name')}</Header>
          <Header>{t('table.birthday')}</Header>
          <Header>{t('table.breed')}</Header>
          <Header>{t('table.pack')}</Header>
          <ActionsHeader></ActionsHeader>
        </Row>
      </thead>
      <tbody>
        {animalsList?.map((animal) => (
          <RowInsured key={animal.id} data={animal} />
        ))}
      </tbody>
    </Table>
  )
}
